import { useState } from "react";
import { DatoTag, TagsContextInterface } from "types/tags";

export function useTagsProvider(tagsParam?: DatoTag[]): {
  tagsContextValue: TagsContextInterface;
  tags: DatoTag[];
} {
  const [tags, setTags] = useState<TagsContextInterface["navigationSets"]>(
    tagsParam ? tagsParam : []
  );

  const tagsContextValue: TagsContextInterface = {
    navigationSets: tags,
    setNavigationSets: (
      navigationSets: TagsContextInterface["navigationSets"]
    ) => {
      setTags(navigationSets);
    },
  };

  return { tagsContextValue, tags };
}
